import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  FormGroup,
  Label,
  Button,
  Input,
  Form,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import querystring from "query-string";
import { object } from "prop-types";
import swal from "sweetalert2";
import moment from "moment-timezone";

import DateRangePicker from "react-dates/lib/components/DateRangePicker";

import TableContainerWithLocation from "../../Components/TableContainerWithLocation";
import TransactionsTable from "@/views/Components/TransactionsTable";
import LoadingOverlay from "../../Components/LoadingOverlay";
import GenerateQrModal from "@/views/Components/QrCode/GenerateQrModal";
import transactions from "@/api/transactions";
import accounts from "@/api/accounts";
import reports from "@/api/reports";
import AccountStatementModal from "./AccountStatementModal";
import { APP_CONST, getStoredItem } from "@/store/dataStore";
import { outsideDateRange } from "@/util/transaction";

import {
  usdViewFormatter,
  khrViewFormatter,
  dateFormatter,
} from "@/util/formatter";

import "react-bootstrap-table/dist/react-bootstrap-table.min.css";
import { handleError } from "@/util/errorHandler";
const txTypes = ["ALL", "SEND_PAY", "DEPOSIT", "RECEIVE"];

class AccountDetail extends Component {
  static propTypes = {
    location: object.isRequired,
  };

  state = {
    user: {
      accountId: "",
      accountType: "",
      address: "",
      balanceKhr: 0,
      balanceUsd: 0,
      createdTime: null,
      email: "string",
      externalId: 0,
      fullName: "",
      id: 0,
      participantBankId: 0,
      phoneNumber: "",
      publicKey: "",
    },
    filter: "",
    from: moment(),
    to: moment(),
    focusedInput: null,
    type: "ALL",

    isDetailsLoading: true,
    isGenerateQrModalOpen: false,
    isAccountStatementModalOpen: false,
    user_permissions: JSON.parse(getStoredItem(APP_CONST.USER_PERMISSIONS)),
    user_authorities: JSON.parse(getStoredItem(APP_CONST.USER_AUTHORITIES)),
  };

  onToggleGenerateQrModal = () => {
    this.setState(({ isGenerateQrModalOpen }) => ({
      isGenerateQrModalOpen: !isGenerateQrModalOpen,
    }));
  };

  onToggleDownloadStatement = () => {
    this.setState(({ isAccountStatementModalOpen }) => ({
      isAccountStatementModalOpen: !isAccountStatementModalOpen,
    }));
  };

  viewFormatter = (cell, row) => (
    <Link
      to={{
        pathname: `/view_transaction/${this.state.user.accountId}/${row.fiTransactionId}`,
        state: { data: row },
      }}>
      <div>
        <i
          className="fa fa-search"
          style={{ color: "#D15050" }}
          data-cy="view-tx"
        />
      </div>
    </Link>
  );

  /* Ref to a TableContainerWithLocation, so we can call its methods */
  table = React.createRef();

  handleInputChange(event) {
    this.setState({
      type: event.target.value,
    });
  }

  handleFilterClick = filter => {
    if (!this.state.from || !this.state.to) {
      swal("Warning", `Please select date range before search`, "warning");
      return;
    }
    const { history, location } = this.props;

    const newQueryParams = filter || {};

    this.setState({ filter: newQueryParams.filter });

    if (this.state.type) {
      newQueryParams.type = this.state.type;
    }

    newQueryParams.from = this.state.from.format(APP_CONST.DATE_FROM);
    newQueryParams.to = this.state.to.format(APP_CONST.DATE_TO);

    const oldSearchQuery = querystring.parse(location.search);
    const newSearchQuery = querystring.stringify({
      ...oldSearchQuery,
      ...newQueryParams,
    });

    history.push({
      ...location,
      search: newSearchQuery,
    });

    setImmediate(() => {
      this.table.loadAndStoreData();
    });
  };

  loadPagination = (
    page = 0,
    size = 10,
    filter = this.state.filter,
    sort = "",
  ) => {
    const from = this.state.from.format(APP_CONST.DATE_FROM);
    const to = this.state.to.format(APP_CONST.DATE_TO);
    const { type } = querystring.parse(this.props.location.search);
    return transactions.getAccountTransactions(
      this.props.match.params.id,
      page,
      size,
      filter,
      sort,
      type,
      from,
      to,
    );
  };

  loadAccountDetails = async id => {
    try {
      return await accounts.getAccountDetails(id).then(data =>
        this.setState({
          user: data,
        }),
      );
    } catch (error) {
      handleError(new Error(error.response));
    } finally {
      this.setState({ isDetailsLoading: false });
    }
  };

  componentDidMount() {
    const id = this.props.match.params.id;

    const { type, from, to } = querystring.parse(this.props.location.search);

    if (type || from || to) {
      this.setState({
        type,
        from: from ? moment(this.state.from, APP_CONST.DATE_FROM) : null,
        to: to ? moment(this.state.to, APP_CONST.DATE_TO) : null,
      });
    }

    this.loadAccountDetails(id);
  }

  goBack = () => {
    /*
     *  WARN: don't change it, because goBack() uses browser history
     *  and returns user just to previous filter in url,
     *  but not previous location in bread crumbs
     */
    const {
      location: { state },
    } = this.props;
    if (state && state.previousLocation) {
      this.props.history.push(state.previousLocation);
    } else {
      this.props.history.push("/total_account");
    }
  };

  handleNavigate = page => {
    setImmediate(() => {
      this.table.loadAndStoreData();
    });
  };

  render() {
    const { user } = this.state;

    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardHeader>
                Account Details: {this.props.match.params.id}
              </CardHeader>
              <CardBody>
                <Row className="mb-4">
                  <Col>
                    <Button
                      color="primary"
                      type="button"
                      onClick={this.goBack}
                      data-cy="back-from-account-detail">
                      <i className="fa fa-arrow-left mr-2 " />
                      Back
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      color="warning"
                      onClick={this.onToggleGenerateQrModal}>
                      <span>Generate QR code</span>
                    </Button>

                    {user.accountType === "MOBILE" && (
                      <Button
                        style={{ marginLeft: 10 }}
                        onClick={this.onToggleDownloadStatement}>
                        <i
                          className="fa fa-download"
                          style={{ marginRight: 5 }}
                        />
                        Generate Statement
                      </Button>
                    )}
                  </Col>
                </Row>

                <Row style={{ position: "relative" }}>
                  <LoadingOverlay loading={this.state.isDetailsLoading} />
                  <Col sm={12} md={6}>
                    <ListGroup>
                      {user.accountType === "MOBILE" && (
                        <ListGroupItem>
                          Fullname: <strong>{user.fullName}</strong>
                        </ListGroupItem>
                      )}
                      {user.accountType !== "MOBILE" && (
                        <ListGroupItem>
                          Organisation: <strong>{user.organizationName}</strong>
                        </ListGroupItem>
                      )}
                      <ListGroupItem>
                        Primary Contact: <strong>{user.primaryContact}</strong>
                      </ListGroupItem>
                      {user.accountType === "MOBILE" && (
                        <ListGroupItem>
                          Secondary Contact:{" "}
                          <strong>{user.secondaryContact}</strong>
                        </ListGroupItem>
                      )}
                      <ListGroupItem>
                        Registered date:{" "}
                        <strong>{dateFormatter(user.createdTime)}</strong>
                      </ListGroupItem>
                      <ListGroupItem>
                        Account type: <strong>{user.accountType}</strong>
                      </ListGroupItem>
                    </ListGroup>
                  </Col>
                  <Col sm={12} md={6}>
                    <h4>Available balance:</h4>
                    <ListGroup>
                      <ListGroupItem>
                        KHR:{" "}
                        <strong>
                          {khrViewFormatter(
                            user.assets && user.assets["khr#nbc"],
                          )}
                        </strong>
                      </ListGroupItem>
                      <ListGroupItem>
                        USD:{" "}
                        <strong>
                          {usdViewFormatter(
                            user.assets && user.assets["usd#nbc"],
                          )}
                        </strong>
                      </ListGroupItem>
                    </ListGroup>
                  </Col>
                </Row>

                <hr />

                <Form
                  inline
                  style={{
                    marginBottom: "1.25rem",
                    justifyContent: "flex-end",
                  }}>
                  <FormGroup
                    className="mb-2 mr-sm-2 mb-sm-0"
                    style={{ paddingRight: "2rem" }}>
                    <DateRangePicker
                      startDate={this.state.from}
                      startDateId="date_from"
                      endDate={this.state.to}
                      endDateId="date_to"
                      onDatesChange={({ startDate, endDate }) =>
                        this.setState({ from: startDate, to: endDate })
                      }
                      focusedInput={this.state.focusedInput}
                      onFocusChange={focusedInput =>
                        this.setState({ focusedInput })
                      }
                      showClearDates
                      showDefaultInputIcon
                      isOutsideRange={date =>
                        moment(date).isAfter(
                          moment.tz("Asia/Phnom_Penh").endOf("day"),
                        ) ||
                        outsideDateRange(this.state.from, this.state.to, date)
                      }
                      small
                      readOnly={true}
                      minimumNights={0}
                    />
                  </FormGroup>
                  <FormGroup
                    className="mb-2 mr-0 pr-0"
                    style={{ paddingRight: "2rem", alignItems: "baseline" }}>
                    <Label htmlFor="type" style={{ marginRight: "1rem" }}>
                      <h6>Transaction Type:</h6>
                    </Label>
                    <Input
                      type="select"
                      name="type"
                      id="type"
                      value={this.state.type}
                      onChange={event => this.handleInputChange(event)}>
                      {txTypes.map(item => {
                        return (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        );
                      })}
                    </Input>
                  </FormGroup>
                </Form>
                <Row>
                  <Col>
                    <TableContainerWithLocation
                      fromAccountDetails={true}
                      autoLoad={true}
                      onSearchClicked={this.handleFilterClick}
                      loadData={this.loadPagination}
                      requestReport={reports.requestAccountTransactions}
                      reportAdditionalParams={this.props.match.params}
                      reportWithoutDateRange={false}
                      reportWithInitialDates={{
                        dateFrom: moment().subtract(
                          APP_CONST.REPORT_BACK_DAYS(),
                          "days",
                        ),
                        dateTo: moment(),
                      }}
                      isTransaction={true}
                      wrappedComponentRef={innerComponent => {
                        // Forwarding ref to TableContainerWithLocation through 'withRouter' HOC
                        // This is the only way to forward ref with React Router 4
                        if (innerComponent) {
                          this.table = innerComponent;
                        }
                      }}>
                      <TransactionsTable
                        type={"account-detail"}
                        onNavigate={this.handleNavigate}
                        isAuditor={this.props.type === "auditor"}
                      />
                    </TableContainerWithLocation>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <GenerateQrModal
              isOpen={this.state.isGenerateQrModalOpen}
              onModalClose={this.onToggleGenerateQrModal}
              userAccountId={this.state.user.accountId}
              organizationName={this.state.user.organizationName}
            />

            <AccountStatementModal
              isOpen={this.state.isAccountStatementModalOpen}
              onModalClose={this.onToggleDownloadStatement}
              userAccountId={this.state.user.accountId}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default AccountDetail;
